import onDocumentReady from '../utils/on-document-ready.js';
import KlaviyoBackInStock from '../modules/forms/klaviyo-back-in-stock.js';

onDocumentReady(() => {
  KlaviyoBackInStock();
});
